<script setup>
import moment from "moment";
moment.locale("id");
</script>

<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div class="container py-5">
          <div
            class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
            style="min-height: 5vh"
          >
            <div style="color: #28293d" class="px-3 pb-2">
              <button @click="$router.back()" class="btn">
                <font-awesome-icon
                  icon="fa-solid fa-arrow-left"
                  style="color: #28293d"
                />
              </button>
              Penilaian Presentasi
            </div>
            <div
              class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
              style="min-height: 60vh"
            >
              <div class="container p-4">
                <!-- Begin Tab Section -->
                <div class="container my-4">
                  <div class="row">
                    <div class="col-md-12 d-flex justify-content-end">
                      <button
                        :hidden="!btnHistory"
                        type="submit"
                        class="btn btn_cari w-25"
                        @click="clickHostory()"
                        v-if="userData.role.includes('ADMIN')"
                      >
                        History Penilaian
                      </button>
                      <button
                        type="submit"
                        class="btn btn_cari w-25 ms-3"
                        @click="clickResume()"
                        v-if="userData.role.includes('ADMIN')"
                      >
                        Resume Penilaian
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 mb-4">
                      <p
                        class="mb-3"
                        style="
                          font-family: 'Inter-Thin';
                          font-size: 0.9rem;
                          letter-spacing: 0.1rem;
                          font-weight: bold;
                        "
                      >
                        PENILAIAN KUSTODIAN
                      </p>

                      <div class="evaluation-table-container">
                        <table class="evaluation-form-table">
                          <tbody>
                          <tr class="evaluation-table-heading">
                            <td style="background-color: #f8d7da">
                              Nama Kustodian
                            </td>
                            <td style="background-color: #f8d7da">
                              Jenis Aspek
                            </td>
                            <td style="background-color: #f8d7da">Aspek</td>
                            <td style="background-color: #f8d7da">
                              Status Dokumen
                            </td>
                            <td style="background-color: #f8d7da">
                              Tanggal Submit
                            </td>
                          </tr>
                          <tr v-if="dataPenilaianKustodian.length == 0">
                            <td colspan="5" class="text-center">
                              Tidak ada data
                            </td>
                          </tr>
                          <template
                            v-for="(
                              dataPenilaian, dataKey, dataIndex
                            ) in dataPenilaianKustodian"
                            :key="dataKey"
                          >
                            <tr
                              v-for="(item, index) in dataPenilaian"
                              :key="index"
                            >
                              <td>
                                {{ index === 0 ? item.namaKustodian : "" }}
                              </td>
                              <td>
                                {{
                                  item.jenis != null
                                    ? capitalized(item.jenis)
                                    : "Administrasi"
                                }}
                              </td>
                              <td>{{ item.aspek }}</td>
                              <td>{{ item.status }}</td>
                              <td>
                                {{
                                  item.submitDate
                                    ? moment(item.submitDate).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""
                                }}
                              </td>
                            </tr>
                            <tr
                              v-if="
                                dataIndex <
                                Object.keys(dataPenilaianKustodian).length - 1
                              "
                            >
                              <td colspan="5"><hr /></td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <p
                        class="mb-3"
                        style="
                          font-family: 'Inter-Thin';
                          font-size: 0.9rem;
                          letter-spacing: 0.1rem;
                          font-weight: bold;
                        "
                      >
                        PENILAIAN PJO
                      </p>

                      <div class="evaluation-tabs">
                        <ul
                          class="nav nav-tabs d-flex bg-white border border-1 shadow-sm p-2"
                          id="evaluationTabs"
                          role="tablist"
                        >
                          <li class="nav-item flex-fill">
                            <a
                              @click="activeTab = 'administrative'"
                              :class="{
                                active: activeTab === 'administrative',
                              }"
                              class="nav-link"
                              id="administrative-tab"
                              data-bs-toggle="tab"
                              href="#administrative-content"
                              role="tab"
                              aria-controls="administrative-content"
                              aria-selected="true"
                              >Penilaian Administratif</a
                            >
                          </li>
                          <li class="nav-item flex-fill">
                            <a
                              @click="activeTab = 'material'"
                              :class="{ active: activeTab === 'material' }"
                              class="nav-link"
                              id="material-tab"
                              data-bs-toggle="tab"
                              href="#material-content"
                              role="tab"
                              aria-controls="material-content"
                              aria-selected="false"
                              >Penilaian Materi Presentasi</a
                            >
                          </li>
                          <li class="nav-item flex-fill">
                            <a
                              @click="activeTab = 'technical'"
                              :class="{ active: activeTab === 'technical' }"
                              class="nav-link"
                              id="technical-tab"
                              data-bs-toggle="tab"
                              href="#technical-content"
                              role="tab"
                              aria-controls="technical-content"
                              aria-selected="false"
                              >Penilaian Kompetensi Teknis Calon PJO</a
                            >
                          </li>
                        </ul>

                        <div class="tab-content" id="evaluationTabsContent">
                          <div
                            class="tab-pane fade show active"
                            id="administrative-content"
                            role="tabpanel"
                            aria-labelledby="administrative-tab"
                          >
                            <penilaianAdministratif
                              v-if="activeTab === 'administrative'"
                              :dataPJO="dataPJO"
                              :dataPenilaianAdmin="dataPenilaianAdmin"
                              :idPenjadwalan="idPenjadwalan"
                              :idPenilaianAdmin="idPenilaianAdmin"
                              :dataSio="dataSio"
                              :submitPenilaian="submitPenilaian"
                              :disabled="disabled"
                            />
                          </div>

                          <div
                            class="tab-pane fade"
                            id="material-content"
                            role="tabpanel"
                            aria-labelledby="material-tab"
                          >
                            <penilaianMateri
                              v-if="activeTab === 'material'"
                              :dataPenilaianMateri="dataPenilaianMateri"
                            />
                          </div>

                          <div
                            class="tab-pane fade"
                            id="technical-content"
                            role="tabpanel"
                            aria-labelledby="technical-tab"
                          >
                            <penilaianTeknis
                              v-if="activeTab === 'technical'"
                              :dataPenilaianKompetensi="dataPenilaianKompetensi"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>

  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- &lt;!&ndash; You can customize the loading content here (e.g., a spinner) &ndash;&gt; -->
    <div>
      <img
        src="@/assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>

  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  ></div>
</template>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  CMS_GET_SIOID,
  CMS_GET_JADWALNILAI,
  CMS_GET_PENILAIANDETAIL,
  CMS_SET_PENILAIAN,
  CMS_GET_HISTORY_PANJADWALAN,
} from "@/constants";

import penilaianAdministratif from "@/pages/sio/penilaian/penilaianAdministratif.vue";
import penilaianMateri from "@/pages/sio/penilaian/penilaianMateri.vue";
import penilaianTeknis from "@/pages/sio/penilaian/penilaianTeknis.vue";
import "@/pages/sio/assets/penilaian-presentasi.css";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_jadwal = API_BASE_URL + CMS_GET_JADWALNILAI;
const url_get_penilaiandetail = API_BASE_URL + CMS_GET_PENILAIANDETAIL;
const url_set_penilaian = API_BASE_URL + CMS_SET_PENILAIAN;
const url_get_history_penjadwalan = API_BASE_URL + CMS_GET_HISTORY_PANJADWALAN;

export default {
  mixins: [GlobalDataMixin],
  name: "PenilaianPresentasi",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
    penilaianAdministratif,
    penilaianMateri,
    penilaianTeknis,
    // Datepicker
  },
  data() {
    return {
      role: "",
      isLoading: true,
      sioID: null,
      kontraktorid: null,
      id: null,
      idPenjadwalan: null,
      idPenilaianAdmin: null,
      idPenilaianKompetensi: [],
      idPenilaianMateri: [],
      dataSio: [],
      jenisPenilaian: ["administrasi", "kompetensi", "presentasi"],
      dataPJO: {
        nama: null,
        perusahaan: null,
        tanggalPresentasi: null,
      },
      dataPenilaianAdmin: null,
      dataPenilaianKompetensi: {},
      dataPenilaianMateri: [],
      dataPenilaianKustodian: [],
      activeTab: "administrative",
      evaluationCustodians: [
        {
          name: "Giorno Giovanna",
          aspek: "Teknis",
          statusDocument: "Submitted",
          submitDate: "10/FEB/2025",
        },
        {
          name: "Buccharati Ivanka Julian Putra",
          aspek: "Aspek Keselamatan Pertambangan",
          statusDocument: "-",
          submitDate: "10/FEB/2025",
        },
        {
          name: "Gunanto Ferdinansyah Pratama",
          aspek: "Aspek Keselamatan Pertambangan",
          statusDocument: "-",
          submitDate: "10/FEB/2025",
        },
      ],
      btnHistory: false,
      disabled: false
    };
  },
  mounted() {
    this.role = "isafe";
    this.sioID = this.$route.params.id;
    this.kontraktorid = this.$route.params.kontraktorid;
    this.idPenjadwalan = this.$route.params.idpenjadwalan;
    this.getSioID(this.kontraktorid);
    this.getJadwal(this.idPenjadwalan);
    this.getPenjadwalan(this.sioID);
  },
  methods: {
    capitalized(name) {
      if (name != null) {
        const capitalizedFirst = name[0].toUpperCase();
        const rest = name.slice(1);
        return capitalizedFirst + rest;
      }
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response nya = ", response);

          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.dataSio = dt;
            this.sioID = dt.id;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getJadwal(idpenjadwalan) {
      axios
        .get(url_get_jadwal + idpenjadwalan, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getJadwal :  ", response);
          //   let dtj = response.data;

          //   this.idPenjadwalan = dtj.idPenjadwalan;
          for (let x = 0; x < this.jenisPenilaian.length; x++) {
            this.getPenilaianDetail(this.idPenjadwalan, this.jenisPenilaian[x]);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getJadwal : " + error);
          console.error("Error fetching data getJadwal :", error);
        });
    },
    getPenilaianDetail(idPenjadwalan, jenis) {
      let bodyJson = {
        idPenjadwalan: idPenjadwalan,
        jenis: jenis,
      };

      axios
        .post(url_get_penilaiandetail, bodyJson, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getPenilaianDetail ", jenis, " : ", response);
          if (response.data !== undefined && response.data !== null) {
            let dt = response.data;
            let dtpenilaian = dt.dataPenilaian;
            if (jenis == "administrasi") {
              this.dataPenilaianKustodian = this.groupDataByKustodian(
                dt.kustodians
              );
              this.dataPJO.nama = dt.pjo;
              this.dataPJO.perusahaan = dt.perusahaan;
              this.dataPJO.tanggalPresentasi = dt.schedule;
              this.idPenilaianAdmin = dtpenilaian[0].id;
              let pn = JSON.parse(dtpenilaian[0].penilaian);
              if (
                JSON.parse(dtpenilaian[0].penilaian).penilaian !== undefined
              ) {
                pn = JSON.parse(dtpenilaian[0].penilaian).penilaian;
              }
              this.dataPenilaianAdmin = pn;
              console.log("this.dataPenilaianAdmin:", this.dataPenilaianAdmin);
            } else if (jenis == "kompetensi") {
              this.dataPenilaianKompetensi = JSON.parse(
                dtpenilaian[0].penilaian
              ).penilaian;
              console.log(
                "this.dataPenilaianKompetensi:",
                this.dataPenilaianKompetensi
              );
            } else if (jenis == "presentasi") {
              this.dataPenilaianMateri = JSON.parse(
                dtpenilaian[0].penilaian
              ).penilaian;
              console.log(
                "this.dataPenilaianMateri:",
                this.dataPenilaianMateri
              );
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error getPenilaianDetail ", jenis, " : ", error);
          alert("error getPenilaianDetail ", jenis, " : ", error);
        })
        .then(() => {});
    },
    submitPenilaian(idpenilaian, jenis) {
      this.disabled = true;
      let bodyJson = {};
      let penilaian = JSON.stringify({ penilaian: this.dataPenilaianAdmin });

      let totskor = 0;
      let tempskor = 0;
      let tempskormax = 0;
      for (let x = 0; x < this.dataPenilaianAdmin.length; x++) {
        let eva = this.dataPenilaianAdmin[x];
        tempskor += eva.skor;
        tempskormax += eva.skorMax;
      }
      totskor = ((tempskor / tempskormax) * 100).toFixed(2);

      if (idpenilaian == null) {
        bodyJson = {
          idPenjadwalan: this.idPenjadwalan,
          penilaian: penilaian,
          jenis: "administrasi",
          created_by: this.userData.id,
          skor: parseFloat(totskor),
          parentAspek: null,
          jenisParent: null,
        };
      } else {
        bodyJson = {
          id: idpenilaian,
          idPenjadwalan: this.idPenjadwalan,
          penilaian: penilaian,
          jenis: "administrasi",
          created_by: this.userData.id,
          skor: parseFloat(totskor),
          parentAspek: null,
          jenisParent: null,
        };
      }

      axios
        .post(url_set_penilaian, bodyJson, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response setPenilaian : ", response);
          this.alertSuksesSubmitPenilaian(jenis);
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error setPenilaian : ", error);
          alert("error setPenilaian : ", error);
        })
        .then(() => {});
    },
    alertSuksesSubmitPenilaian(jenis) {
      let msg_title = "";
      let msg_text = "";
      if (jenis == "administrasi") {
        msg_title = "Simpan Penilaian Berhasil";
        msg_text = "Penilaian Administrasi Berhasil Disimpan!";
      } else if (jenis == "kompetensi") {
        msg_title = "Simpan Penilaian Berhasil";
        msg_text = "Penilaian Kompetensi Berhasil Disimpan!";
      } else if (jenis == "presentasi") {
        msg_title = "Simpan Penilaian Berhasil";
        msg_text = "Penilaian Materi Presentasi Berhasil Disimpan!";
      }
      // this.isLoading = false
      Swal.fire({
        title: msg_title,
        text: msg_text,
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
        window.location.reload();
      });
    },
    clickResume() {
      this.$router.push("/resumePenilaian/" + this.idPenjadwalan);
    },
    clickHostory() {
      this.$router.push("/historyPenilaian/" + this.sioID);
    },
    groupDataByKustodian(data) {
      return data.reduce((groups, item) => {
        const key = item.namaKustodian;
        if (!groups[key]) {
          groups[key] = [];
        }
        groups[key].push(item);
        return groups;
      }, {});
    },
    getPenjadwalan(id_sio) {
      let bodyJson = {
        idSio: id_sio,
      };

      axios
        .post(url_get_history_penjadwalan, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getPenjadwalan => ", response);
          this.btnHistory = response.data.id != null ? true : false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
/* datepicker */
section {
  font-family: "Inter", sans-serif;
  font-style: normal;
  min-height: 100vh;
}

section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}

/* tabs */
.evaluation-tabs .nav-tabs {
  border-bottom: none;
  border-radius: 50px; /* Rounded corners */
  /* background-color: #f8f9fa;  */
}

.evaluation-tabs .nav-item {
  margin-bottom: 0; /* Remove if you have a border */
}

.evaluation-tabs .nav-link {
  border: 1px solid transparent;
  border-radius: 50px; /* Rounded corners */
  color: #495057; /* Text color for inactive tabs */
  background-color: #f8f9fa; /* Background color for inactive tabs */
  margin-right: 5px; /* Spacing between tabs */
  transition: all 0.3s ease; /* Smooth transition for hover and active states */
}

.evaluation-tabs .nav-link:hover {
  border: 1px solid #f8f9fa; /* Border color on hover */
  background-color: #fff; /* Background color on hover */
}

.evaluation-tabs .nav-link.active {
  color: #fff; /* Text color for active tab */
  background-color: #dc3545; /* Background color for active tab */
  border-color: #dc3545; /* Border color for active tab */
  z-index: 1; /* Ensure the active tab overlays the inactive tabs */
}

.evaluation-tabs .nav-link {
  padding: 0.5rem 1rem;
  font-size: 1rem;
}

.evaluation-tabs .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

#evaluationTabsContent {
  margin-top: 20px;
}

/* .tab-content {
  border: 1px solid #f8f9fa;
  padding: 1rem;
  background-color: #f8f9fa;
}

.tab-pane {
  color: #495057;
} */
</style>
